import { render, staticRenderFns } from "./PtZones.vue?vue&type=template&id=2c948f23&"
import script from "./PtZones.vue?vue&type=script&lang=js&"
export * from "./PtZones.vue?vue&type=script&lang=js&"
import style0 from "./PtZones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports